export default __webpack_public_path__ + "static/media/feed.187a1d5b.png";